import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Home() {
  return (
    <>
      <div class="main-banner">
        <div class="main-banner-item banner-item-five">
          <div class="container">
            <div class="main-banner-content">
              <h1>Simple, Fast and Secure</h1>
              <p>Whether you're growing your personal wealth or scaling your business, we provide tailored financial solutions, expert guidance, and secure tools to help you reach your banking goals with confidence.</p>
              <div class="banner-btn">
                <Link to={"/register"} class="default-btn">Get started</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="about-area bg-ffffff ptb-100">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about-image">
                <a to="https://www.youtube.com/watch?v=-67xX2__1oM" class="video-btn popup-youtube">
                  <i class='bx bx-play'></i>
                </a>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="about-content">
                <span>About Pargati</span>
                <h3>We operate our services in many countries around the world.</h3>
                <p>Go cashless with Pargati app. You can pay mobile, gas, electricity, DTH, broadband bills and recharges. Pargati is a revolutionary app to make mobile payments in Nepal in a secure and simple way.</p>

                <div class="about-btn">
                  <Link to={"/about"} class="default-btn">About us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="fun-facts-area ptb-100">
        <div class="container">
          <div class="section-title">
            <span>Why choose us</span>
            <h2>Pargati Online Service has been serving customers for nearly 10 years.</h2>
          </div>

          <div class="fun-facts-inner">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                  <h3>
                    <span class="odometer" data-count="358412">50000+</span>
                  </h3>
                  <p>Happy customers</p>
                </div>
              </div>

              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                  <h3>
                    <span class="odometer" data-count="25">10</span>
                  </h3>
                  <p>Years in service</p>
                </div>
              </div>

              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                  <h3>
                    <span class="odometer" data-count="2545">2</span>
                  </h3>
                  <p>Our branches</p>
                </div>
              </div>

              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                  <h3>
                    <span class="odometer" data-count="54285">14,976</span>
                  </h3>
                  <p>Successfully works</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="protect-area pb-100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6">
              <div class="protect-content">
                <span>Protect your money</span>
                <h3>We make every effort to ensure our customers’ money is well protected.</h3>
                <div class="protect-inner-content">
                  <div class="number">
                    <span>1</span>
                  </div>
                  <h4>Bank-Level Security</h4>
                  <p>Your funds are safeguarded using advanced security measures to ensure maximum protection.</p>
                </div>
                <div class="protect-inner-content">
                  <div class="number">
                    <span>2</span>
                  </div>
                  <h4>Best-in-Class Investments</h4>
                  <p>We offer reliable and carefully selected investment solutions for long-term value.</p>
                </div>
                <div class="protect-inner-content">
                  <div class="number">
                    <span>3</span>
                  </div>
                  <h4>Secure Asset Monitoring</h4>
                  <p>Track and manage your assets safely with continuous monitoring and control.</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="protect-image"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="services-area bg-transparent pt-100 pb-70">
        <div class="container">
          <div class="section-title">
            <span>Banking services</span>
            <h2>Our bank provides various services to our customers.</h2>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="single-services-item">
                <div class="icon">
                  <i class="flaticon-mobile-banking"></i>
                </div>
                <h3><Link to="services">Nepal/Indian Recharge</Link></h3>
                <p>Recharge your mobile in Nepal/Indian easily and instantly with our reliable service.</p>
                <Link to="services" class="learn-btn">Learn more <i class="flaticon-right-arrow"></i></Link>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-services-item">
                <div class="icon">
                  <i class="flaticon-mobile-banking"></i>
                </div>
                <h3><Link to="services">Prabhu Money Transfer</Link></h3>
                <p>Send money safely and instantly through Prabhu Money Transfer services.</p>
                <Link to="services" class="learn-btn">Learn more <i class="flaticon-right-arrow"></i></Link>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-services-item">
                <div class="icon">
                  <i class="flaticon-mobile-banking"></i>
                </div>
                <h3><Link to="services">IME Money Transfer</Link></h3>
                <p>Transfer funds with ease using IME Money Transfer services across Nepal and abroad.</p>
                <Link to="services" class="learn-btn">Learn more <i class="flaticon-right-arrow"></i></Link>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="single-services-item">
                <div class="icon">
                  <i class="flaticon-mobile-banking"></i>
                </div>
                <h3><Link to="services">Pragati Bazaar</Link></h3>
                <p>Access a wide range of products and services through Pragati Bazaar with convenience.</p>
                <Link to="services" class="learn-btn">Learn more <i class="flaticon-right-arrow"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="below-area ptb-100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6">
              <div class="below-image"></div>
            </div>

            <div class="col-lg-6">
              <div class="below-content">
                <span>How to Open an Account</span>
                <h3>Opening a account requires completing the following steps:</h3>
                <div class="below-inner-content">
                  <div class="number">
                    <span>1</span>
                  </div>
                  <h4>Personal Details</h4>
                  <p>Applicants must provide accurate personal information, including full name, date of birth, contact details, and email address.</p>
                </div>
                <div class="below-inner-content">
                  <div class="number">
                    <span>2</span>
                  </div>
                  <h4>Identification</h4>
                  <p>Valid identification documents, such as a national identity card, pan card, or driver’s license, must be submitted for verification purposes.</p>
                </div>
                <div class="below-inner-content">
                  <div class="number">
                    <span>3</span>
                  </div>
                  <h4>Address Information</h4>
                  <p>Applicants are required to submit proof of their residential address, such as a recent utility bill, lease agreement, or official document.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="app-area ptb-100">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="app-content">
                <h3>Download our App to get all kinds of banking benefits from anywhere</h3>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="app-btn">
                <a to="#" class="app-store-btn">
                  <i class="flaticon-apple"></i>
                  Download on
                  <span>App store</span>
                </a>

                <a href="https://play.google.com/store/apps/details?id=com.gws.pargati.paypoint&hl=en_IN" target="_blank" class="play-store-btn">
                  <i class="flaticon-google-play"></i>
                  Download on
                  <span>Google play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="customer-area ptb-100">
        <div class="container">
          <div class="section-title">
            <span>Customers say</span>
            <h2>What customers say about Us</h2>
          </div>
          <OwlCarousel
            className='customer-slider owl-theme'
            loop
            nav
            navText={['<i class="flaticon-left-arrow"></i>', '<i class="flaticon-right-arrow"></i>']}
          >
            <div class="customer-item">
              <img src="assets/images/customer-1.jpg" alt="Customer image" />
              <p>
                “The account opening process was simple and straightforward. The support team was very helpful and guided me through every step.”
              </p>
              <div class="customer-info">
                <h3>Robert Jakech</h3>
                <span>Software Engineer</span>
              </div>
              <div class="icon">
                <i class="flaticon-right-quotation-mark"></i>
              </div>
            </div>
            <div class="customer-item">
              <img src="assets/images/customer-2.jpg" alt="Customer image" />
              <p>
                “Excellent service and fast response time. I was impressed by how easy it was to manage everything online.”
              </p>
              <div class="customer-info">
                <h3>Joseph Nakabale</h3>
                <span>Software Engineer</span>
              </div>
              <div class="icon">
                <i class="flaticon-right-quotation-mark"></i>
              </div>
            </div>
            <div class="customer-item">
              <img src="assets/images/customer-1.jpg" alt="Customer image" />
              <p>
                “I appreciate the clear communication and user-friendly platform. It made the entire experience smooth and stress-free.”
              </p>
              <div class="customer-info">
                <h3>Robert Jakech</h3>
                <span>Software Engineer</span>
              </div>
              <div class="icon">
                <i class="flaticon-right-quotation-mark"></i>
              </div>
            </div>
            <div class="customer-item">
              <img src="assets/images/customer-2.jpg" alt="Customer image" />
              <p>
                “Reliable, secure, and easy to use. I would definitely recommend this service to anyone looking for a trusted banking solution.”
              </p>
              <div class="customer-info">
                <h3>Joseph Nakabale</h3>
                <span>Software Engineer</span>
              </div>
              <div class="icon">
                <i class="flaticon-right-quotation-mark"></i>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>
      <section class="subscribe-area ptb-100">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="subscribe-content">
                <span>Get Started Instantly!</span>
                <h2>Get Only New Update from this Newsletter</h2>
              </div>
            </div>

            <div class="col-lg-6">
              <form class="newsletter-form" data-toggle="validator">
                <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" required autocomplete="off" />

                <button type="submit">Subscribe</button>
                <div id="validator-newsletter" class="form-result"></div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div class="partner-area bg-fafafa ptb-100">
        <div class="container">
          <OwlCarousel className='partner-slider owl-theme' loop>
            <div class="partner-item">
              <img src="assets/images/partner-1.png" alt="image" />
            </div>

            <div class="partner-item">
              <img src="assets/images/partner-2.png" alt="image" />
            </div>

            <div class="partner-item">
              <img src="assets/images/partner-3.png" alt="image" />
            </div>

            <div class="partner-item">
              <img src="assets/images/partner-4.png" alt="image" />
            </div>

            <div class="partner-item">
              <img src="assets/images/partner-5.png" alt="image" />
            </div>
          </OwlCarousel>
        </div>
      </div>
    </>
  );
}

export default Home;
